import * as React from 'react';

export const useOnWindowScroll = (onScroll: () => void) => {
  React.useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);
};
